import {LOAD_SHOPS, START, SUCCESS} from "../constants";

const initialState = {
  shopList: [],
  loading: false,
  loaded: false,
  urlHash: '',
  urlHashIndex: '',
};

export default (state = initialState, action) => {
  const {type, payload, response} = action;

  switch (type) {
    case LOAD_SHOPS + START:
      return { ...state, loaded : false, loading : true };

    case LOAD_SHOPS + SUCCESS:
      // console.log('LOAD_SHOPS')
        const urlHashLength = payload.url_hash && payload.url_hash.length === 3;
        const urlHashHave = response.findIndex(el => el.url_hash === payload.url_hash);
      // console.log(urlHashLength)
      // console.log(urlHashHave)
        // const hashUrl = urlHash ? urlHashHave : (urlHashHave === -1 ? -1 : '');
        // let hashUrl = '';
        // if(urlHashLength && urlHashHave !== -1) {
        //     hashUrl = urlHashHave
        // // } else if(payload.url_hash && payload.url_hash.length < 3 || payload.url_hash && payload.url_hash.length > 3) {
        // //     console.log('z4')
        // //     hashUrl = -1
        // } else if(urlHashLength === undefined) {
        //     hashUrl = 0
        // } else {
        //     hashUrl = -1
        // }
        // console.log(hashUrl && hashUrl !== -1 ? urlHashHave : '')
        return { ...state, shopList: [...response], loaded : true, loading : false, urlHashIndex: urlHashHave};

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/shops.js